const ja = {
  a11yVideoLabelText: "顔のライフネスチェックを示すビデオ",
  cameraMinSpecificationsHeadingText: "カメラの最小仕様",
  cameraMinSpecificationsMessageText:
    "カメラがライフネスチェックに必要な最小仕様を満たしていることを確認してください。",
  cameraNotFoundHeadingText: "カメラが見つかりません",
  cameraNotFoundMessageText:
    "カメラを検出できませんでした。カメラが接続されていることを確認し、再試行してください。",
  cancelLivenessCheckText: "ライフネスチェックをキャンセル",
  clientHeaderText: "クライアントメッセージ",
  clientMessageText:
    "画面の指示に従って顔のライフネスチェックを完了してください。",
  connectionTimeoutHeaderText: "接続タイムアウト",
  connectionTimeoutMessageText:
    "接続がタイムアウトしました。インターネット接続を確認し、再試行してください。",
  errorLabelText: "エラー",
  faceDistanceHeaderText: "顔の距離",
  faceDistanceMessageText:
    "顔がカメラから適切な距離にあることを確認してください。",
  goodFitAltText: "顔がよく揃っています",
  goodFitCaptionText: "顔がよく揃っています。動かないでください。",
  hintCanNotIdentifyText: "顔を識別できません。再試行してください。",
  hintCenterFaceInstructionText: "顔をフレームの中央に配置してください。",
  hintCenterFaceText: "顔を中央に配置",
  hintCheckCompleteText: "チェック完了",
  hintConnectingText: "接続中...",
  hintFaceDetectedText: "顔が検出されました",
  hintFaceOffCenterText: "顔が中央からずれています。調整してください。",
  hintHoldFaceForFreshnessText: "チェックのために顔を動かさないでください。",
  hintIlluminationNormalText: "照明は良好です",
  hintIlluminationTooBrightText: "照明が明るすぎます",
  hintIlluminationTooDarkText: "照明が暗すぎます",
  hintMatchIndicatorText: "顔のインジケータを照合中...",
  hintMoveFaceFrontOfCameraText: "顔をカメラの前に移動してください",
  hintTooCloseText: "カメラに近すぎます",
  hintTooFarText: "カメラから遠すぎます",
  hintTooManyFacesText:
    "顔が多すぎます。フレームに1つの顔のみである必要があります。",
  hintVerifyingText: "確認中...",
  landscapeHeaderText: "ランドスケープモードが検出されました",
  landscapeMessageText:
    "ライフネスチェックのためにポートレートモードに切り替えてください。",
  multipleFacesHeaderText: "複数の顔が検出されました",
  multipleFacesMessageText:
    "フレームに1つの顔のみである必要があります。調整して再試行してください。",
  photosensitivityWarningBodyText:
    "このチェックには一連の視覚刺激が含まれます。光感受性の問題がある場合は注意して進めてください。",
  photosensitivityWarningHeadingText: "光感受性警告",
  photosensitivityWarningInfoText:
    "不快に感じた場合はいつでもチェックを中止できます。",
  photosensitivityWarningLabelText: "リスクを理解しています",
  portraitMessageText: "デバイスをポートレートモードに保持してください。",
  recordingIndicatorText: "録画中",
  retryCameraPermissionsText: "カメラの許可を再試行",
  serverHeaderText: "サーバーの問題",
  serverMessageText:
    "サーバーへの接続に問題が発生しました。後でもう一度お試しください。",
  startScreenBeginCheckText: "ライフネスチェックを開始",
  timeoutHeaderText: "タイムアウト",
  timeoutMessageText: "プロセスがタイムアウトしました。再試行してください。",
  tooFarAltText: "顔がカメラから遠すぎます",
  tooFarCaptionText: "カメラに近づいてください。",
  tryAgainText: "再試行",
  waitingCameraPermissionText: "カメラの許可を待っています...",
};

export default ja;
